import { partners } from "@hagerty/self-service-components/types/providerResponses/shared";
import {
  LoginFeatureFlag,
  FeatureFlagOptions,
  FeatureFlags,
  ESignFeatureFlag,
  BillingFeatureFlag,
} from ".";

export const defaultFeatureFlags: FeatureFlags = {
  FAKE_PARTNER: "off",
  FAKE_LOGIN: "off",
  ESIGN: "off",
  BILLING: "base",
};

/** An array of all supported feature flags. */
export const featureFlagKeys = Object.keys(defaultFeatureFlags);

export const defaultTestFeatureFlags = {
  FAKE_PARTNER: "off",
  FAKE_LOGIN: "off",
  ESIGN: "off",
  BILLING: "base",
} as const;

const base: BillingFeatureFlag = "base";

const hagerty: LoginFeatureFlag = "off";
const sso: LoginFeatureFlag = "sso";
const LoginFeatureFlags: LoginFeatureFlag[] = [hagerty, sso];
const ESignFeatureFlags: ESignFeatureFlag[] = ["off", "on"];
const BillingFeatureFlags: BillingFeatureFlag[] = ["base", "new"];

export const defaultPartnerOptions: FeatureFlagOptions = {
  values: ["off", ...partners],
  defaultValue: "off",
} as const;

export const defaultLoginOptions: FeatureFlagOptions = {
  values: LoginFeatureFlags,
  defaultValue: hagerty,
} as const;

export const defaultESignOptions: FeatureFlagOptions = {
  values: ESignFeatureFlags,
  defaultValue: "off",
} as const;

export const defaultBillingOptions: FeatureFlagOptions = {
  values: BillingFeatureFlags,
  defaultValue: base,
} as const;
